import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  name: string,
 *  enabled: boolean }} NotificationListItem
 */

/**
 * @typedef {{
 *  id: number,
 *  name: string,
 *  selected: boolean }} NotificationRecipient
 */

/**
 * @typedef {{
 *  id: number,
 *  text: string,
 *  description: boolean }} NotificationPlaceholder
 */

/**
 * @typedef {{
 *  id: number,
 *  name: string,
 *  purpose: string,
 *  to: NotificationRecipient[],
 *  cc: NotificationRecipient[],
 *  placeholders: NotificationPlaceholder[],
 *  subject: string,
 *  body: string,
 *  enabled: boolean }} Notification
 */

const api = new Api("api/notifications");

/**
 * @returns {Promise<AxiosResponse<NotificationListItem[]>>}
 */
export const getAll = () => api.get();

/**
 * @param {number} id
 * @returns {Promise<AxiosResponse<Notification>>}
 */
export const getById = (id) => api.get(id);

export const update = (id, payload) => api.putId(id, payload);
